export var breakpoints = [['xs', 0], ['sm', 768], ['lg', 1024], ['xl', 1366]];